<uni-icon
  class="uni-nav-back__icon"
  name="chevron-left"
></uni-icon>
<div>{{ 'label.back' | translate }}</div>
